import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {StateWithUserAddressState, USER_ADDRESS_ZONE, UserAddressState} from '../reducers/user-addresses-zone.reducer';
import {LoaderState} from '../../../state/utils/loader/loader-state';
import {Address, StateUtils} from '@spartacus/core';

export interface AddressState {
  entities: Address[];
  zone: string;
}

export const getUserAddressesState: MemoizedSelector<StateWithUserAddressState, UserAddressState> =
  createFeatureSelector<UserAddressState>(USER_ADDRESS_ZONE);

export const getAddressesLoaderState: MemoizedSelector<
  StateWithUserAddressState,
  LoaderState<AddressState>
> = createSelector(getUserAddressesState, (state: UserAddressState) => state.addressesZone);

export const getAddressesByZone: MemoizedSelector<
  StateWithUserAddressState,
  AddressState
> = createSelector(getAddressesLoaderState, (state: LoaderState<AddressState>) =>
  StateUtils.loaderValueSelector(state)
);

export const getAddressesByZoneLoading: MemoizedSelector<
  StateWithUserAddressState,
  boolean
> = createSelector(getAddressesLoaderState, (state: LoaderState<AddressState>) =>
  StateUtils.loaderLoadingSelector(state)
);

export const getAddressesByZoneLoadedSuccess: MemoizedSelector<
  StateWithUserAddressState,
  boolean
> = createSelector(
  getAddressesLoaderState,
  (state: LoaderState<AddressState>) =>
    StateUtils.loaderSuccessSelector(state) &&
    !StateUtils.loaderLoadingSelector(state)
);


export const getAddressesDataAndLoading: MemoizedSelector<
  StateWithUserAddressState,
  {
    loaded: boolean;
    loading: boolean;
    addresses: Address[];
    zone: string;
  }
  > = createSelector(
  getAddressesLoaderState,
  (state: LoaderState<AddressState>) => ({
    loaded: StateUtils.loaderSuccessSelector(state),
    loading: StateUtils.loaderLoadingSelector(state),
    addresses: StateUtils.loaderValueSelector(state).entities,
    zone: StateUtils.loaderValueSelector(state).zone,
  })
);
